"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _reactI18next = require("react-i18next");
var _dateFns = require("date-fns");
var _globalComponentsLibrary = require("global-components-library");
var _types = require("../../../utils/types");
var _constants = require("../../../utils/constants");
var _ChatMessage = _interopRequireDefault(require("./ChatMessage"));
var _emptyChatPh = _interopRequireDefault(require("../../../images/empty-chat-ph.png"));
var _NewMessageBar = _interopRequireDefault(require("../../NewMessageBar/NewMessageBar"));
require("./ChatView.scss");
var _helpers = require("../../../utils/helpers");
var _ChatFooter = _interopRequireDefault(require("./ChatFooter"));
var _DragAndDropFile = _interopRequireDefault(require("../../DragAndDrop/DragAndDropFile"));
var _MediaViewerAttachment = _interopRequireDefault(require("../../MediaViewer/MediaViewerAttachment"));
var _hooks = require("../../../utils/hooks");
var _DateDivider = _interopRequireDefault(require("../../common/DateDivider/DateDivider"));
var _ReassignDivider = _interopRequireDefault(require("../../common/ReassignDivider/ReassignDivider"));
var _ImageIcon = _interopRequireDefault(require("../../common/ImageIcon/ImageIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DisabledBanner = function DisabledBanner() {
  var _useTranslation = (0, _reactI18next.useTranslation)(['chat', 'commons']),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-chat-disabled-banner' + (open ? '' : ' hide')
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon send-disabled large"
  }), /*#__PURE__*/_react["default"].createElement("span", null, t('disabled')), /*#__PURE__*/_react["default"].createElement(_globalComponentsLibrary.Button, {
    color: "tertiary",
    onClick: function onClick() {
      return setOpen(false);
    }
  }, t('commons:ok')));
};
var ChatView = function ChatView(_ref) {
  var _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? [] : _ref$messages,
    type = _ref.type,
    userImage = _ref.userImage,
    typing = _ref.typing,
    templates = _ref.templates,
    disabled = _ref.disabled,
    disabledActions = _ref.disabledActions,
    onSendResponse = _ref.onSendResponse,
    lang = _ref.lang,
    contact = _ref.contact,
    agent = _ref.agent,
    onAceptedChat = _ref.onAceptedChat,
    onSpam = _ref.onSpam,
    onUnassign = _ref.onUnassign,
    onFinish = _ref.onFinish,
    show = _ref.show,
    onUploadAttachments = _ref.onUploadAttachments,
    onDeleteAttachment = _ref.onDeleteAttachment,
    setTheUrlOfAttachments = _ref.setTheUrlOfAttachments,
    setStartConversation = _ref.setStartConversation,
    startConversation = _ref.startConversation,
    conversationId = _ref.conversationId,
    onLoadMessages = _ref.onLoadMessages,
    isEnableHistoricalChat = _ref.isEnableHistoricalChat,
    isFetchingMessages = _ref.isFetchingMessages,
    isAllConversations = _ref.isAllConversations,
    lastConversations = _ref.lastConversations,
    maxImgToSend = _ref.maxImgToSend,
    onDialog = _ref.onDialog,
    campType = _ref.campType,
    onShowAlertDisconexion = _ref.onShowAlertDisconexion,
    setNumFiles = _ref.setNumFiles,
    getUploadState = _ref.getUploadState;
  var _useTranslation2 = (0, _reactI18next.useTranslation)('chat'),
    t = _useTranslation2.t;
  var areaRef = (0, _react.useRef)();
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragOver = _useState4[0],
    setDragOver = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    groupedMessages = _useState6[0],
    setGroupedMessages = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    attachmentPreview = _useState8[0],
    setAttachmentPreview = _useState8[1];
  var tempAttachments = (0, _react.useRef)([]);
  var _useState9 = (0, _react.useState)(-1),
    _useState10 = _slicedToArray(_useState9, 2),
    selectedFile = _useState10[0],
    setSelectedFile = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isLoading = _useState12[0],
    setIsLoading = _useState12[1];
  var _useState13 = (0, _react.useState)(0),
    _useState14 = _slicedToArray(_useState13, 2),
    speedSelected = _useState14[0],
    setSpeedSelected = _useState14[1];
  var _useState15 = (0, _react.useState)(null),
    _useState16 = _slicedToArray(_useState15, 2),
    currentAudio = _useState16[0],
    setCurrentAudio = _useState16[1];
  var refDates = (0, _react.useRef)([]);
  var refDateSticky = (0, _react.useRef)();
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    memoryScrollTop = _useState18[0],
    setMemoryScrollTop = _useState18[1];
  var _useState19 = (0, _react.useState)(0),
    _useState20 = _slicedToArray(_useState19, 2),
    memoryScrollHeight = _useState20[0],
    setMemoryScrollHeight = _useState20[1];
  var loadMessages = function loadMessages() {
    onLoadMessages();
    setTimeout(function () {
      return setMemoryScrollTop(false);
    }, 10500);
  };
  var _useInfiniteScrollWit = (0, _hooks.useInfiniteScrollWithRefCallback)(loadMessages, isEnableHistoricalChat && !isAllConversations, setMemoryScrollTop, setMemoryScrollHeight, refDates, refDateSticky),
    _useInfiniteScrollWit2 = _slicedToArray(_useInfiniteScrollWit, 4),
    setRefChatZone = _useInfiniteScrollWit2[0],
    isFetching = _useInfiniteScrollWit2[1],
    setIsFetching = _useInfiniteScrollWit2[2],
    refChatZone = _useInfiniteScrollWit2[3];
  (0, _react.useEffect)(function () {
    if (!isFetchingMessages) {
      setTimeout(function () {
        return setIsFetching(false);
      }, 1000);
    }
  }, [isFetchingMessages]);
  (0, _globalComponentsLibrary.useUpdateEffect)(function () {
    if (refChatZone != null) {
      if (memoryScrollTop) {
        refChatZone.scrollTop = Math.max(refChatZone.scrollHeight - memoryScrollHeight - 92, 100);
      } else {
        refChatZone.scrollTop = refChatZone.scrollHeight;
      }
    }
  }, [groupedMessages]);
  var changeSpeed = function changeSpeed() {
    var speedTmp = speedSelected + 1;
    if (speedTmp > 2) {
      speedTmp = 0;
    }
    setSpeedSelected(speedTmp);
  };
  var groupem = function groupem() {
    if (messages != null) {
      if (messages.length > 0) {
        var newObj = messages.reduce(function (acc, curr, i, arr) {
          if (i === 0 || curr.origin !== arr[i - 1].origin || !(0, _dateFns.isSameMinute)(curr.date, arr[i - 1].date)) {
            acc.index++;
            acc.arr[acc.index] = {
              source: curr.origin,
              date: curr.date,
              conversationId: curr.conversationId,
              originName: curr.originName,
              fromAgent: curr.fromAgent,
              content: [{
                type: curr.type ? curr.type : 'text',
                status: curr.status,
                texts: [],
                attachments: [],
                messageIds: []
              }],
              contentIndex: 0,
              campType: curr.campType,
              graphicId: curr.graphicId
            };
          } else if (arr[i - 1].type !== curr.type || arr[i - 1].status !== curr.status) {
            acc.arr[acc.index].content.push({
              type: curr.type ? curr.type : 'text',
              status: curr.status,
              texts: [],
              attachments: [],
              messageIds: []
            });
            acc.arr[acc.index].contentIndex++;
          }
          if (curr.type == null || curr.type === 'text' || curr.type === 'template') {
            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].texts.push(curr.content);
          } else if (curr.type === 'location') {
            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].attachments.push({
              url: curr.location.Url
            });
          } else if (curr.type !== 'unsupported') {
            var indexUrl = curr.attachments.Url.indexOf('|');
            var newUrl = curr.attachments.Url;
            var fileName = curr.attachments.Name;
            var fileSize = curr.attachments.Size;
            if (indexUrl > -1) {
              var elementSplit = curr.attachments.Url.split('|');
              newUrl = elementSplit[0];
              if (newUrl.indexOf('/v3/') > -1) {
                newUrl = newUrl.split('/v3/')[0];
              }
              fileSize = elementSplit[1];
              fileName = elementSplit[2];
            }
            acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].attachments.push({
              caption: curr.type === 'file' ? null : curr.attachments.Caption,
              url: newUrl,
              size: fileSize,
              name: fileName
            });
          }
          acc.arr[acc.index].status = (0, _helpers.isNewMedia)(type) ? curr.status : curr.seen ? 'read' : 'delivered';
          acc.arr[acc.index].content[acc.arr[acc.index].contentIndex].messageIds.push(curr.messageId);
          return acc;
        }, {
          arr: [],
          index: -1
        });
        setGroupedMessages(newObj.arr);
      } else if (groupedMessages.length > 0) {
        setGroupedMessages([]);
      }
    }
  };
  (0, _react.useLayoutEffect)(groupem, [messages]);
  var onAceptedChatHandler = function onAceptedChatHandler(isTimeOut) {
    setStartConversation(function () {
      return false;
    });
    onAceptedChat();
    setTimeout(function () {
      if (isTimeOut) {
        setTimeout(function () {
          onFinish();
        }, 200);
      }
      areaRef.current.focus();
    }, 500);
  };
  var onDragOver = function onDragOver(e) {
    e.preventDefault();
    if (!show) {
      setDragOver(true);
    }
  };
  (0, _react.useEffect)(function () {
    if (startConversation) {
      onAceptedChatHandler(true);
    }
  }, [startConversation]);
  var timeoutRef = (0, _react.useRef)(null);
  var onUploadAttachmentsHandler = function onUploadAttachmentsHandler(files) {
    tempAttachments.current = files;
    onUploadAttachments(files);
    setNumFiles(files.length);
    timeoutRef.current = setTimeout(function () {
      console.log('onTimeout Response');
      setIsLoading(false);
      setDragOver(false);
      if (!getUploadState()) {
        onShowAlertDisconexion();
      }
    }, 10000);
  };
  var onDeleteAttachmentHandler = function onDeleteAttachmentHandler(url) {
    onDeleteAttachment(url);
    setAttachmentPreview(function (a) {
      return a.filter(function (f) {
        return f.url !== url;
      });
    });
    setSelectedFile(function (s) {
      return s - 1;
    });
  };
  (0, _react.useEffect)(function () {
    if (setTheUrlOfAttachments != null && setTheUrlOfAttachments.length > 0) {
      if (setTheUrlOfAttachments.length === 1 && setTheUrlOfAttachments[0].name === 'audio.ogg') {
        onSendResponseHandler([setTheUrlOfAttachments[0]]);
      } else if (tempAttachments.current.length > 0) {
        var filesToSet = tempAttachments.current.filter(function (f) {
          return setTheUrlOfAttachments.some(function (g) {
            return g.name === f.name;
          });
        });
        setAttachmentPreview(function (a) {
          return [].concat(_toConsumableArray(a), _toConsumableArray(filesToSet.map(function (f) {
            var file = setTheUrlOfAttachments.find(function (g) {
              return g.name === f.name;
            });
            return {
              name: f.name,
              url: (0, _helpers.urlFormatHelper)(file.url),
              size: file.size,
              type: file.type
            };
          })));
        });
        tempAttachments.current = tempAttachments.current.filter(function (f) {
          return !filesToSet.some(function (g) {
            return g.name === f.name;
          });
        });
        setIsLoading(false);
        setDragOver(false);
        clearTimeout(timeoutRef.current);
      }
    }
  }, [setTheUrlOfAttachments]);
  (0, _react.useEffect)(function () {
    setSelectedFile(attachmentPreview.length - 1);
  }, [attachmentPreview]);
  var onCloseModal = function onCloseModal() {
    attachmentPreview.forEach(function (f) {
      return onDeleteAttachment(f.url);
    });
    setAttachmentPreview([]);
  };
  var onSendResponseHandler = function onSendResponseHandler(val) {
    if (_typeof(val) === 'object') {
      val.forEach(function (v) {
        var message = '';
        var arr = {};
        arr = {
          Caption: message,
          Url: v.url,
          Size: v.size,
          Name: v.name
        };
        setTimeout(function () {
          onSendResponse('', arr, v.type);
        }, 1000);
      });
      setAttachmentPreview([]);
      return;
    }
    onSendResponse(val);
  };
  /* useEffect(() => {
  	if (attach.length > 0) {
  		onDragLeaveEndHandler();
  		if (isLoading) setIsLoading(false);
  	}
  }, [attach]); */

  var onDragLeaveEndHandler = function onDragLeaveEndHandler() {
    if (dragOver) setDragOver(false);
  };
  (0, _react.useEffect)(function () {
    setCurrentAudio(null);
  }, [conversationId]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-view",
    onDragOver: onDragOver
  }, dragOver && /*#__PURE__*/_react["default"].createElement(_DragAndDropFile["default"], {
    onChange: onUploadAttachmentsHandler,
    onDragLeaveEnd: onDragLeaveEndHandler,
    mediaType: type,
    maxImgToSend: maxImgToSend
  }), isLoading && !dragOver && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-chat-conversation-attaching"
  }, /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-loading-label"
  }, "".concat(t('loading'), "..."))), disabled && type === 'CHAT' && /*#__PURE__*/_react["default"].createElement(DisabledBanner, null), attachmentPreview.length > 0 && attachmentPreview[selectedFile] ? /*#__PURE__*/_react["default"].createElement(_MediaViewerAttachment["default"], {
    toggle: onCloseModal,
    media: attachmentPreview[selectedFile].url,
    mediaType: attachmentPreview[selectedFile].type,
    fileName: attachmentPreview[selectedFile].name,
    fileSize: attachmentPreview[selectedFile].size
  }) : messages.length === 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-empty"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-empty-image"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: _emptyChatPh["default"],
    alt: "Empty placeholder"
  })), /*#__PURE__*/_react["default"].createElement("p", {
    className: "uin-empty-message"
  }, t('no-messages'))) : /*#__PURE__*/_react["default"].createElement("div", {
    ref: setRefChatZone,
    className: 'uin-chat-conversation' + (show ? ' uin-chat-not-started' : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'uin-loading-conversation' + (isFetching ? ' show' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-loading-label"
  }, "".concat(t('loading-messsages'), "...")), /*#__PURE__*/_react["default"].createElement(_reactstrap.Spinner, {
    color: "primary"
  })), isEnableHistoricalChat && /*#__PURE__*/_react["default"].createElement("div", {
    className: "uin-date-label-container"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    ref: refDateSticky,
    id: "uin-date-label"
  })), groupedMessages.map(function (group, i) {
    var prevConv = lastConversations.find(function (c) {
      return c.ConversationId === group.conversationId;
    });
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: i
    }, isEnableHistoricalChat && (i === 0 || i > 0 && (0, _dateFns.isBefore)(new Date(groupedMessages[i - 1].date).setHours(0, 0, 0, 0), new Date(group.date).setHours(0, 0, 0, 0))) && /*#__PURE__*/_react["default"].createElement(_DateDivider["default"], {
      index: i,
      ref: refDates,
      lang: lang,
      date: group.date
    }), isEnableHistoricalChat && i > 0 && groupedMessages[i - 1].conversationId !== group.conversationId && prevConv != null && prevConv.IsReassigned && /*#__PURE__*/_react["default"].createElement(_ReassignDivider["default"], {
      userAgent: group.fromAgent
    }), /*#__PURE__*/_react["default"].createElement(_ChatMessage["default"], _extends({
      image: /*#__PURE__*/_react["default"].createElement(_ImageIcon["default"], {
        image: group.graphicId,
        type: group.campType,
        showTooltip: false
      })
    }, group, {
      disabled: type !== 'WHATSAPP' ? disabled : false,
      type: type,
      speedSelected: speedSelected,
      changeSpeed: changeSpeed,
      currentAudio: currentAudio,
      setCurrentAudio: setCurrentAudio,
      isEnableHistoricalChat: isEnableHistoricalChat
    })));
  }), typing && /*#__PURE__*/_react["default"].createElement(_ChatMessage["default"], {
    image: userImage,
    typing: true,
    speedSelected: speedSelected,
    changeSpeed: changeSpeed,
    currentAudio: currentAudio,
    setCurrentAudio: setCurrentAudio
  })), show ? /*#__PURE__*/_react["default"].createElement(_NewMessageBar["default"], {
    disabled: disabledActions,
    onAceptedChat: function onAceptedChat() {
      return onAceptedChatHandler();
    },
    onSpam: onSpam,
    onUnassign: onUnassign
  }) : '', /*#__PURE__*/_react["default"].createElement(_ChatFooter["default"], {
    ref: areaRef,
    templates: templates,
    contact: contact,
    agent: agent,
    disabled: disabled || disabledActions,
    mediaType: type,
    media: attachmentPreview,
    selectedAttachment: selectedFile,
    onSelectAttachment: setSelectedFile,
    onSendResponse: onSendResponseHandler,
    onUploadAttachments: onUploadAttachmentsHandler,
    onDeleteAttachment: onDeleteAttachmentHandler,
    onLoading: setIsLoading,
    maxImgToSend: maxImgToSend,
    onDialog: onDialog
  }), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
    return g.source !== _constants.MSG_SOURCE.USER && g.status === 'delivered';
  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-chat-msg-dlr"
  }, t('delivered')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
    return g.source !== _constants.MSG_SOURCE.USER && g.status === 'read';
  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-chat-msg-rd"
  }, t('read')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
    return g.source === _constants.MSG_SOURCE.ADMIN;
  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-chat-msg-vis-A"
  }, t('can-see')), !(0, _helpers.isNewMedia)(type) && groupedMessages.some(function (g) {
    return g.source === _constants.MSG_SOURCE.COACH;
  }) && /*#__PURE__*/_react["default"].createElement(_reactstrap.UncontrolledTooltip, {
    target: "uin-chat-msg-vis-C"
  }, t('cant-see')));
};
ChatView.propTypes = {
  messages: _propTypes["default"].arrayOf(_types.messageType),
  userImage: _propTypes["default"].element,
  typing: _propTypes["default"].bool,
  templates: _propTypes["default"].arrayOf(_types.templateType),
  disabled: _propTypes["default"].bool,
  onSendResponse: _propTypes["default"].func.isRequired,
  onSpam: _propTypes["default"].func,
  onAceptedChat: _propTypes["default"].func,
  onUnassign: _propTypes["default"].func,
  startConversation: _propTypes["default"].bool,
  setStartConversation: _propTypes["default"].func
};
ChatView.defaultProps = {
  lastConversations: []
};
var _default = exports["default"] = ChatView;


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/components/ConversationView/ChatView/ChatView.js
// module id = 1402
// module chunks = 0